import { defineComponent as _defineComponent } from 'vue';
import { computed, ref, onMounted, onUnmounted } from "vue";
import { flattenTools } from "../utilities.js";
import DelayedInput from "@/components/Common/DelayedInput.vue";
import _l from "@/utils/localization";
import { useRouter } from "vue-router/composables";
import { getGalaxyInstance } from "@/app";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ToolSearch',
    props: {
        currentPanelView: {
            type: String,
            required: true,
        },
        enableAdvanced: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: "search tools",
        },
        query: {
            type: String,
            default: null,
        },
        queryPending: {
            type: Boolean,
            default: false,
        },
        showAdvanced: {
            type: Boolean,
            default: false,
        },
        toolbox: {
            type: Array,
            required: true,
        },
    },
    emits: ["update:show-advanced", "onResults", "onQuery"],
    setup(__props, { emit }) {
        const props = __props;
        const router = useRouter();
        const KEYS = { exact: 3, name: 2, description: 1, combined: 0 };
        const FAVORITES = ["#favs", "#favorites", "#favourites"];
        const MIN_QUERY_LENGTH = 3;
        const filterSettings = ref({});
        const showHelp = ref(false);
        const searchWorker = ref(undefined);
        const sectionNames = computed(() => {
            return props.toolbox.map((section) => section.name !== undefined && section.name !== "Uncategorized" ? section.name : "");
        });
        const sectionLabel = computed(() => {
            return props.currentPanelView === "default" ? "section" : "ontology";
        });
        const toolsList = computed(() => {
            return flattenTools(props.toolbox);
        });
        onMounted(() => {
            searchWorker.value = new Worker(new URL("../toolSearch.worker.js", import.meta.url));
            const Galaxy = getGalaxyInstance();
            const favoritesResults = Galaxy === null || Galaxy === void 0 ? void 0 : Galaxy.user.getFavorites().tools;
            searchWorker.value.onmessage = ({ data }) => {
                const { type, payload, query, closestTerm } = data;
                if (type === "searchToolsByKeysResult" && query === props.query) {
                    emit("onResults", payload, closestTerm);
                }
                else if (type === "clearFilterResult") {
                    emit("onResults", null, null);
                }
                else if (type === "favoriteToolsResult") {
                    emit("onResults", favoritesResults, null);
                }
            };
        });
        onUnmounted(() => {
            var _a;
            (_a = searchWorker.value) === null || _a === void 0 ? void 0 : _a.terminate();
        });
        function checkQuery(q) {
            filterSettings.value["name"] = q;
            emit("onQuery", q);
            if (q && q.length >= MIN_QUERY_LENGTH) {
                if (FAVORITES.includes(q)) {
                    post({ type: "favoriteTools" });
                }
                else {
                    post({
                        type: "searchToolsByKeys",
                        payload: {
                            tools: toolsList.value,
                            keys: KEYS,
                            query: q,
                        },
                    });
                }
            }
            else {
                post({ type: "clearFilter" });
            }
        }
        function post(message) {
            var _a;
            (_a = searchWorker.value) === null || _a === void 0 ? void 0 : _a.postMessage(message);
        }
        function onSearch() {
            for (const [filter, value] of Object.entries(filterSettings.value)) {
                if (!value) {
                    delete filterSettings.value[filter];
                }
            }
            router.push({ path: "/tools/list", query: filterSettings.value });
        }
        function onToggle(toggleAdvanced) {
            emit("update:show-advanced", toggleAdvanced);
        }
        return { __sfc: true, router, KEYS, FAVORITES, MIN_QUERY_LENGTH, props, emit, filterSettings, showHelp, searchWorker, sectionNames, sectionLabel, toolsList, checkQuery, post, onSearch, onToggle, DelayedInput, _l };
    }
});
